import { Box, Button, Typography } from '@material-ui/core';
import ChromeReaderModeOutlinedIcon from '@material-ui/icons/ChromeReaderModeOutlined';
import HomeIcon from '@material-ui/icons/Home';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import clsx from 'clsx';
import { Link } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useStyles } from './bottom-navbar.style';
import NavigationMenu from './navigation-menu';

export const BottomNavbar: React.FC = () => {
    const classes = useStyles();
    const [menuOpen, setMenuOpen] = React.useState<boolean>(false);
    const { pathname } = useLocation();
    const { t } = useTranslation();

    const navItems = [
        {
            label: t('navigationMenu:home'),
            icon: <HomeIcon />,
            value: '/',
        },
        {
            label: t('navigationMenu:jobs'),
            icon: <WorkOutlineIcon />,
            value: '/jobs',
        },
        {
            label: t('navigationMenu:blog'),
            icon: <ChromeReaderModeOutlinedIcon />,
            value: '/blog',
        },
    ];

    const toggleMenu = () => {
        setMenuOpen((prev) => !prev);
    };

    const closeMenu = () => setMenuOpen(false);

    return (
        <Box className={classes.root}>
            {navItems.map((nav) => {
                return (
                    <Link to={nav.value} key={nav.label} className={classes.navItem}>
                        <Button
                            className={clsx(nav.value === pathname && classes.active)}
                            color="default"
                            startIcon={nav.icon}
                            onClick={closeMenu}
                        >
                            <Typography>{nav.label}</Typography>
                        </Button>
                    </Link>
                );
            })}
            <Button
                color="default"
                startIcon={<MoreHorizOutlinedIcon />}
                onClick={toggleMenu}
                className={clsx(classes.navItem, menuOpen && classes.active)}
                style={{ padding: 0 }}
            >
                <Typography>{t('navigationMenu:more')}</Typography>
            </Button>
            {menuOpen && <NavigationMenu onCloseNavigationMenu={closeMenu} />}
        </Box>
    );
};
